import { render, staticRenderFns } from "./EntityKnowledgeGraph.vue?vue&type=template&id=334aca8f&scoped=true"
import script from "./EntityKnowledgeGraph.vue?vue&type=script&lang=js"
export * from "./EntityKnowledgeGraph.vue?vue&type=script&lang=js"
import style0 from "./EntityKnowledgeGraph.vue?vue&type=style&index=0&id=334aca8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334aca8f",
  null
  
)

export default component.exports